import React from 'react';

const ProfileCard = ({ profile, onAvatarClick }) => {
  const { name = '', shopName = '', email = '', phone = '', avatar = '' } = profile;

  // Generate initials
  const getInitials = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <div className="profile-summary-card">
      <div className="profile-avatar-container" onClick={onAvatarClick} style={{ cursor: onAvatarClick ? 'pointer' : 'default' }}>
        {avatar ? (
          <img src={avatar} alt={name} />
        ) : (
          <span>{getInitials(name) || 'U'}</span>
        )}
        {onAvatarClick && (
          <div className="profile-avatar-camera-btn">
            <span style={{ fontSize: '11px' }}>📷</span>
          </div>
        )}
      </div>

      <div className="profile-info-details">
        <h3>{name || 'Wholesale Buyer'}</h3>
        {shopName && <div className="profile-shop-name">{shopName}</div>}
        
        <div className="profile-contacts-list">
          {email && (
            <div className="profile-meta-row">
              <span className="profile-meta-icon">✉</span>
              <span className="profile-meta-text">{email}</span>
            </div>
          )}
          {phone && (
            <div className="profile-meta-row">
              <span className="profile-meta-icon">☎</span>
              <span className="profile-meta-text">{phone}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
